import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import i18n from 'i18next';
import { Button, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useIsMount } from '../../../../../../../hooks/useIsMountHook';
import ElevioTooltip from '../../../../../../../components/overlays/helpTooltip/TitleHelpTooltip/ElevioTooltip';
import ServicePicker from '../../../../../../../components/ui/servicePicker/ServicePicker';
import { Service, Tag } from '../../../../../../../types/rest/assetCatalogTypes';
import { DEFAULT_POPPER_CONFIG } from '../../../../../../../constants/ui-constants';
import TagSelector from '../../../../../../../components/selectors/TagSelector';
import { saveHttpRecordingThunk } from '../../../../../../../store/mockServices/mockServiceDetail/mockServiceDetailActions';

interface ConvertHttpRecordingModalProps {
  recordingIds: any[];
  onCloseModal: () => void;
  isConvertedOpen: boolean;
  recordingTags: string[];
}

const ConvertHttpRecordingModal: React.FC<ConvertHttpRecordingModalProps> = ({
  recordingIds,
  onCloseModal,
  isConvertedOpen,
  recordingTags,
}) => {
  const [serviceId, setServiceId] = useState<number>(0);
  const [selectedTags, setSelectedTags] = useState<string>(recordingTags.toString());

  const isMount = useIsMount();
  const dispatch = useDispatch();
  const onModalConvert = () => {
    const params = {
      serviceId: serviceId,
      tags: selectedTags.trim() === '' ? undefined : selectedTags,
    };
    const dto = { analyticIds: recordingIds };
    dispatch(saveHttpRecordingThunk(dto, params));
    resetFields();
  };

  useEffect(() => {
    if (!isMount) {
      setSelectedTags(recordingTags.toString());
    }
  }, [recordingTags]);

  const resetFields = () => {
    setServiceId(0);
    setSelectedTags('');
    onCloseModal();
  };

  return (
    <Modal show={isConvertedOpen} centered={true} backdrop={true} onHide={resetFields} size="sm">
      <Modal.Header closeButton id={'converter-view'}>
        <h5 className="modal-title" id="exampleModalLabel">
          {i18n.t('recordings:convertToTxModal.titleSave')}
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className={'form-group'}>
          <span>
            <label htmlFor="converterServicePicker">{i18n.t('recordings:convertToTxModal.service')}</label>
            <ElevioTooltip
              elevioId={'Services_import_transactions'} //TODO: Add elevioId
              title={i18n.t('recordings:convertToTxModal.serviceElevioTooltip')}
            />
          </span>
          <ServicePicker
            selectHandler={(vs: Service | null) => setServiceId(vs?.id || 0)}
            isSelectAll={false}
            isCreateEnabled={true}
            manualPreLoad={true}
            preSelected={serviceId}
            maxHeight="230px"
            popperConfig={DEFAULT_POPPER_CONFIG}
            id="converterServicePicker"
            focus={true}
          />
        </div>
        <Form.Group controlId="qa-input-tags-converter">
          <label htmlFor={'react-select-multiple'}>{i18n.t('recordings:convertToTxModal.tagsLabel')}</label>
          <TagSelector
            preSelected={recordingTags}
            selectHandler={(tags: Tag[]) => setSelectedTags(tags.map(t => t.name).toString())}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button id={'modal-btn-cancel'} variant="link" onClick={resetFields}>
          {i18n.t('recordings:convertToTxModal.cancel')}
        </Button>
        <Button disabled={serviceId === 0} id={'modal-btn-converter'} variant="primary" onClick={onModalConvert}>
          {i18n.t('recordings:convertToTxModal.save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConvertHttpRecordingModal;
